<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>


<div class="body" [style]="errormsg? 'margin: 1% 2% 0% 3%;':  'margin: 1% 2% 4.8% 3%;'">
    <br>
    <div>
        <label class="catlabel">Tier Name<span style="color:#ff0000">*</span></label>
        <input type="text" class="content" [(ngModel)]="tierName">

    </div>
    <div>
        <label class="catlabel">Tier Position<span style="color:#ff0000">*</span></label>
        <input type="number" class="content" [(ngModel)]="tierPosition" min=1>

    </div>
    <div>
        <label class="catlabel">TLMS Route Type Code<span style="color:#ff0000">*</span></label>
        <!-- <p-multiSelect [options]="tlmsRouteTypeCodeData" [(ngModel)]="selectedTlmsRouteTypeCodeArrayObject"
            [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [showHeader]="false"
            styleClass="fixed-select" optionLabel="value" appendTo="body"></p-multiSelect> -->
        <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedTlmsRouteTypeCodeArrayObject" [multiple]="true"  >
                <mat-option *ngFor="let option of tlmsRouteTypeCodeData" [value]="option">
                    {{ option.value }}
                </mat-option>
            </mat-select>
        </mat-form-field>

    </div>
    <div>
        <label class="catlabel">Master Table</label>

        <!-- <p-dropdown [options]="masterTableData" [(ngModel)]="selectedMasterTableObject" optionLabel="value"
            [autoDisplayFirst]="false" styleClass="fixed-select" [showClear]="true" appendTo="body"></p-dropdown> -->

            <mat-form-field appearance="outline" class="fixed-select">
                <mat-select [(ngModel)]="selectedMasterTableObject"   [disableOptionCentering]="true">
                  <mat-option *ngFor="let option of masterTableData" [value]="option">
                    {{ option.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

    </div>
    <div>
        <label class="catlabel">Dependency</label>

        <!-- <p-dropdown [options]="dependencyData" [(ngModel)]="selectedDependencyObject" optionLabel="value"
            [autoDisplayFirst]="false" styleClass="fixed-select" [showClear]="true" appendTo="body">
        </p-dropdown> -->

        <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedDependencyObject"   [disableOptionCentering]="true">
              <mat-option *ngFor="let option of dependencyData" [value]="option">
                {{ option.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
    </div>
    <div>

        <label class="catlabel">Lock Trigger</label>

        <!-- <p-dropdown [options]="lockTriggerData" [(ngModel)]="selectedLockTriggerObject" optionLabel="value"
            [autoDisplayFirst]="false" styleClass="fixed-select" [showClear]="true" appendTo="body">
        </p-dropdown> -->

        <mat-form-field appearance="outline" class="fixed-select">
            <mat-select [(ngModel)]="selectedLockTriggerObject"   [disableOptionCentering]="true">
              <mat-option *ngFor="let option of lockTriggerData" [value]="option">
                {{ option.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>

    </div>

    <div>
        <label class="catlabel">Other Tier Data</label>
        <!-- <p-multiSelect [options]="includeOtherTierData" [(ngModel)]="selectedIncludeOtherTierArrayObject"
            [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [showHeader]="false"
            styleClass="fixed-select" optionLabel="value" appendTo="body"></p-multiSelect> -->

            <mat-form-field appearance="outline" class="fixed-select">
                <mat-select [(ngModel)]="selectedIncludeOtherTierArrayObject" [multiple]="true"  >
                  <mat-option *ngFor="let option of includeOtherTierData" [value]="option">
                    {{ option.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
    </div>

</div>


<label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
<div class=" footer">
    <button (click)="onNoClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
    <button mat-raised-button class="submit" style="display: inline;" (click)="saveClick()">SAVE</button>
</div>